import React from 'react';

export default ({ group: { name } }) => (
  <li>
    <span>{name}</span>
  </li>
);
